<template>
	<section class="mainContentBlo " :class="classCustom">
		<router-view v-slot="{ Component, route }">
			<transition name="fade-transform" mode="out-in">
				<keep-alive :include="useUserStore().cachedViews">
					<component v-if="!route.meta.link" :is="Component" :key="route.path + componentKey" />
				</keep-alive>
			</transition>
		</router-view>
	</section>
</template>

<script setup>
	import useUserStore from '@/store/modules/user'
	const componentKey = ref(0)
	
	const classCustom = ref(null)
	const router = useRouter()
	const path = router.currentRoute.value.path
	
	// 20260603 新增模块详情/项目介绍 小尺寸时直接截断
	function getClassCustom(path) {
		if (path === '/moduleAndRequirementCreateAndEditAndDetails' || path === '/projectCreateAndIntroduceAndEdit') {
			classCustom.value = 'overflowH'
		}
	}
	
	onMounted(() => {
		getClassCustom(path)
	})
	
	watch(router.currentRoute, (newVal, old) => {
		getClassCustom(newVal.path)
	})
	
	// 捕获组件错误
	onErrorCaptured((error, instance, info) => {
	  if (error.message.includes('Failed to fetch dynamically imported module')) {
	    // 方案1: 强制刷新当前组件
	    componentKey.value++
		console.warn('动态模块加载失败，尝试刷新页面 componentKey.value, error, info', componentKey.value, error, info)
	    
	    // 方案2: 重定向到首页并刷新
	    // window.location.reload()
	    
	    return false // 阻止错误继续传播
	  }
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";
	
	.mainContentBlo {
		min-height: calc(100vh - #{$navHeight});
		width: 100%;
		position: relative;
	}
</style>
